import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Why the session ended, so the overlay can explain it accurately:
 * - `expired`: the token is past its expiry (the usual case)
 * - `updated`: the stored session predates a breaking change to the session payload,
 *   so it is unusable even though it has not expired yet
 */
export type SessionEndedReason = 'expired' | 'updated';

@Injectable({ providedIn: 'root' })
export class SessionExpiredService {
  private readonly _expired = new BehaviorSubject<boolean>(false);
  readonly expired$ = this._expired.asObservable();

  private readonly _reason = new BehaviorSubject<SessionEndedReason>('expired');
  readonly reason$ = this._reason.asObservable();

  show(reason: SessionEndedReason = 'expired'): void {
    this._reason.next(reason);
    this._expired.next(true);
  }

  hide(): void {
    this._expired.next(false);
  }
}
